import React from 'react';
const PageHeading = ({ eyebrow, title, description, children }) => (
  <div className="page-heading">
    <div>
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h1>{title}</h1>
      {description && <p className="page-description">{description}</p>}
    </div>
    {children && <div className="page-heading__actions">{children}</div>}
  </div>
);
export default PageHeading;
